import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';

/*
  InfoBanner: the standard informational banner for hints and empty states
  (drag-to-reorder notes, "no results" messages, layer warnings). Soft blue
  fill with a blue info icon — one definition so every page shows the same
  banner instead of ad-hoc styled Alerts.
*/
const InfoBanner = ({ children, onClose, sx }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1.25,
      bgcolor: '#eff8ff',
      borderRadius: 2,
      px: 2,
      py: 1.5,
      ...sx,
    }}
  >
    <InfoOutlined sx={{ fontSize: 20, color: '#1570ef', flexShrink: 0, mt: '1px' }} />
    <Typography variant="body2" sx={{ color: 'text.primary', lineHeight: 1.5, flex: 1, minWidth: 0 }}>
      {children}
    </Typography>
    {onClose && (
      <IconButton size="small" onClick={onClose} aria-label="Dismiss" sx={{ p: 0.25, mt: '-2px', color: 'text.secondary' }}>
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    )}
  </Box>
);

export default InfoBanner;
